"use client";

import React, { useState, useEffect, useRef, Suspense } from "react";
import { SliderBannerCollection } from "@packages/lib/types/interfaces";
import { graphQlFetchFunction } from "@packages/lib/server-actions/server-action";
// import { searchPanelQuery } from "@packages/lib/graphQL/graphql-query";
import HeroSliderCard from "@packages/shared-components/common-utilities/cards/hero-card/heroslidercard";
import Searchboxwrapper from "@packages/shared-components/common-utilities/searchBar/search-pod/searchboxwrapper";
import HeroSliderComponentSkeleton from "@packages/shared-components/skeleton/heroslidercomponentskeleton";
import { getDynamicSeachQuery } from "@packages/lib/graphQL/graphql-query";

interface PropsInterface {
  data: SliderBannerCollection;
  pageName?: any;
}

const Heroslidercomponent = ({ data, pageName }: PropsInterface) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [universalSearchPanel, setUniversalSearchPanel] = useState<any>(null);
  const slideInterval = useRef<NodeJS.Timeout | null>(null);
  const [screenWidth, setScreenWidth] = useState(0);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % (data?.items?.length || 1));
    }, 4000);
  };

  const pauseSlideTimer = () => {
    if (slideInterval.current) {
      clearInterval(slideInterval.current);
    }
  };

  // const fetchUniversalSearchPanel = async () => {
  //   try {
  //     const res = await graphQlFetchFunction(searchPanelQuery, false);
  //     const panelData =
  //       res?.data?.contentData?.items[0]?.universalSearchPanel
  //         ?.navigationElementsCollection?.items;
  //     setUniversalSearchPanel(panelData);
  //   } catch (error) {
  //     console.error("Error fetching universal search panel:", error);
  //   }
  // };

  useEffect(() => {
    // fetchUniversalSearchPanel();

    const handleUserInteraction = () => {
      if (!slideInterval.current) {
        startSlideTimer();
      }
    };

    const fetchData = async () => {
      try {
        const result = await graphQlFetchFunction(
          getDynamicSeachQuery(),
          false
        );
        const panelItems =
          result?.data?.homepageCollection?.items[0]?.searchPanel
            ?.navigationElementsCollection?.items || [];
        setUniversalSearchPanel(panelItems);
      } catch (error) {
        console.error("Failed to fetch universal search panel data:", error);
      }
    };

    fetchData();

    window.addEventListener("click", handleUserInteraction);
    window.addEventListener("mousemove", handleUserInteraction);
    window.addEventListener("touchstart", handleUserInteraction);

    return () => {
      pauseSlideTimer();
      window.removeEventListener("click", handleUserInteraction);
      window.removeEventListener("mousemove", handleUserInteraction);
      window.removeEventListener("touchstart", handleUserInteraction);
    };
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const updateWidth = () => {
      setScreenWidth(window.innerWidth);
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return (
    <section className="bg-grey-50">
      <Suspense fallback={<HeroSliderComponentSkeleton />}>
        <div
          data-testid="hero-banner-colour"
          className={`${
            process.env.PROJECT === "Whatuni" ? "bg-blue-200" : "bg-green-200"
          } px-[16px] md:px-[20px] xl2:px-0`}
        >
          <div className="max-w-container mx-auto">
            {/* Slider */}
            <div className="relative w-full md:h-[442px] overflow-hidden">
              {/* Slides */}
              <div
                className={`flex flex-row relative ${screenWidth < 768 ? "w-fit" : "w-full"}  h-full box-content z-0`}
              >
                {data?.items?.map((childItems, index) => {
                  const spacing = 32;
                  const slideOffset = -((screenWidth - spacing) * index);
                  const styles =
                    screenWidth < 768
                      ? {
                          transform: `translate3d(${slideOffset}px, 0, 0)`,
                          opacity: index === currentSlide ? 1 : 0,
                          width: `${screenWidth - spacing}px`,
                        }
                      : {};

                  return (
                    <div
                      style={styles}
                      key={index}
                      className={`${screenWidth < 768 ? "relative" : "absolute"}  inset-0 w-full h-full transition-opacity duration-1000 ease-in-out ${
                        index === currentSlide
                          ? "opacity-100 z-20"
                          : "opacity-0 z-10"
                      }`}
                    >
                      <HeroSliderCard
                        data={childItems}
                        index={index}
                        pageName={pageName}
                      />
                    </div>
                  );
                })}
              </div>

              {/* Pagination Dots */}
              <div className="absolute top-[50px] lg:top-[74px] left-0 flex gap-[4px] z-1">
                {data?.items?.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    data-text-id={`hero_slide_${index + 1}_button`}
                    className={`h-[8px] rounded-[4px] ${
                      currentSlide === index
                        ? "w-[16px] bg-primary-400 transition-all duration-300"
                        : "w-[8px] bg-primary-100 transition-all duration-300"
                    }`}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </div>

        <Searchboxwrapper universalSearchPanel={universalSearchPanel} />
      </Suspense>
    </section>
  );
};

export default Heroslidercomponent;
